export const SET_CREATE_EVENT_FORM_STEP = "SET_CREATE_EVENT_FORM_STEP";

export const SET_CREATED_EVENT_ID = "SET_CREATED_EVENT_ID";

export const SET_ACTIVE_PUBLISH_MODE = "SET_ACTIVE_PUBLISH_MODE";
